// @flow
import type { ReduxState } from '../types';
export const searchStateSelector = (state: any): ReduxState => {
  return state.search;
};
